import useDeleteDocuments from "ApiLayer/Documents/mutationDeleteDocuments";
import useDownloadDocument from "ApiLayer/Documents/mutationDownloadDocument";
import useQueryListDocuments from "ApiLayer/Documents/queryListDocuments";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import { Delete, DocumentIcon, ImportIcon } from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip/Tooltip";
import { Header } from "components/atoms/Typography";
import DangerousModal from "components/molecules/DangerousModal";
import DocumentUploadModal from "components/organisms/Modals/DocumentUploadModal/DocumentUploadModal";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { useState } from "react";
import { BuildingSectionProps } from "../BuildingConstruction.constants";
import styles from "./DocumentUpload.module.scss";

function DocumentUpload(props: BuildingSectionProps) {
    const buildingModelUid = useBuildingModelUid();

    const { isEditing } = props;
    const { data: buildingDocuments } = useQueryListDocuments(buildingModelUid);
    const { mutate: deleteDocument } = useDeleteDocuments(buildingModelUid);
    const { mutate: downloadDocument } = useDownloadDocument(buildingModelUid);

    const uploadedDocuments: DocumentResponse[] = buildingDocuments ?? [];

    const [uploadModalIsOpen, setUploadModalIsOpen] = useState(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
    const [documentToDelete, setDocumentToDelete] = useState<DocumentResponse>();

    const deleteDocumentModalOptions = {
        title: "Delete file",
        body: `This will delete ${documentToDelete?.file_name}`,
    };

    const handleDownloadDocument = (document: DocumentResponse) => {
        downloadDocument(document.gcs_path);
    };

    const handeDeleteDocument = () => {
        if (documentToDelete?.upload_uid) {
            deleteDocument(documentToDelete?.upload_uid, {
                onSuccess: () => {
                    setDeleteModalIsOpen(false);
                    setDocumentToDelete(undefined);
                },
            });
        }
    };

    return (
        <>
            <div className="construction-sidebar__body__header">
                <DocumentIcon />
                <Header size="medium">Documents</Header>
            </div>

            <div className={classNames("construction-sidebar__body__section", isEditing && "editing")}>
                <div
                    className={classNames(
                        "construction-sidebar__body__property",
                        "construction-sidebar__body__stackedList",
                        isEditing && styles.deleteRow
                    )}
                >
                    {uploadedDocuments.map((document) => {
                        const title = (
                            <span className={styles.documentTitle} title={document.file_name}>
                                {document.file_name}
                            </span>
                        );
                        return (
                            <div key={document.upload_uid} className={styles.row}>
                                <div className={styles.documentHeader}>
                                    <div className={styles.documentTitleWrap}>
                                        {document.description ? (
                                            <Tooltip tooltipBody={document.description}>{title}</Tooltip>
                                        ) : (
                                            title
                                        )}
                                    </div>
                                    <div className={styles.iconActions}>
                                        <button
                                            type="button"
                                            onClick={() => handleDownloadDocument(document)}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                padding: 0,
                                                cursor: "pointer",
                                            }}
                                            aria-label="Download document"
                                        >
                                            <ImportIcon />
                                        </button>
                                        {isEditing && (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setDeleteModalIsOpen(true);
                                                    setDocumentToDelete(document);
                                                }}
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    padding: 0,
                                                    cursor: "pointer",
                                                }}
                                                aria-label="Delete document"
                                            >
                                                <Delete />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {uploadedDocuments.length === 0 && (
                        <Header size="small" style={{ color: "var(--audette-gray-500)" }}>
                            No document uploaded
                        </Header>
                    )}
                </div>
                {isEditing && (
                    <div className="filters-sidebar__body">
                        <div className={classNames("construction-sidebar__body__section", "editing")}>
                            <Button
                                type="primary"
                                id="edit-construction-save-button"
                                // disabled={saveButtonIsDisabled}
                                onClick={() => {
                                    setUploadModalIsOpen(!uploadModalIsOpen);
                                }}
                            >
                                Upload
                            </Button>
                        </div>
                    </div>
                )}
            </div>
            <DocumentUploadModal modalIsOpen={uploadModalIsOpen} onCancel={() => setUploadModalIsOpen(false)} />
            <DangerousModal
                open={deleteModalIsOpen}
                onCancel={() => setDeleteModalIsOpen(false)}
                onDelete={handeDeleteDocument}
                options={deleteDocumentModalOptions}
                styleType="primary-negative"
                loading={false}
            />
        </>
    );
}

export default DocumentUpload;
